import {useMemo, useCallback} from 'react';
import {IProductOption} from '../../../../../types/galleryTypes';
import {IProductSelectionAvailabilityMap} from '@wix/wixstores-client-core/dist/es/src/productVariantCalculator/ProductVariantCalculator';

interface UseOptionSelectionLogicParams {
  option: IProductOption;
  selectionIds: number[];
  selectionsAvailability: IProductSelectionAvailabilityMap[string];
}

export const useOptionSelectionLogic = ({
  option,
  selectionIds,
  selectionsAvailability,
}: UseOptionSelectionLogicParams) => {
  const visibleSelections = useMemo(
    () => option?.selections?.filter((selection) => selectionsAvailability?.[selection.id]?.isVisible) || [],
    [option.selections, selectionsAvailability]
  );

  const selectedSelectionId = useMemo(
    () => option?.selections?.find((selection) => selectionIds?.includes(selection.id))?.id.toString(),
    [option.selections, selectionIds]
  );

  const isSelectionDisabled = useCallback(
    (selectionId: number) => !selectionsAvailability?.[selectionId]?.isSelectable,
    [selectionsAvailability]
  );

  const isSelectionChecked = useCallback((selectionId: number) => selectionIds?.includes(selectionId), [selectionIds]);

  const calculateNextSelectionIds = useCallback(
    (pickedSelectionId: number) => {
      const currentSelectionIds = selectionIds ?? /* istanbul ignore next */ [];
      const unchangedSelections = currentSelectionIds.filter(
        (selectionId) => !visibleSelections?.find(({id}) => id === selectionId)
      );
      return [...unchangedSelections, pickedSelectionId];
    },
    [selectionIds, visibleSelections]
  );

  return {
    visibleSelections,
    selectedSelectionId,
    isSelectionDisabled,
    isSelectionChecked,
    calculateNextSelectionIds,
  };
};
